var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { loc } from "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import "../internals/BaseHeader.js";
import BaseFooter from "../internals/BaseFooter.js";
import BaseForm from "../internals/BaseForm.js";
import "../internals/BaseFormWithPolling.js";
import "../internals/BaseOktaVerifyChallengeView.js";
import BaseView from "../internals/BaseView.js";
import "../components/AuthenticatorEnrollOptions.js";
import "../components/AuthenticatorVerifyOptions.js";
import "../../../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import "cross-fetch";
import "../../../util/BrowserFeatures.js";
import "../../../util/FactorUtil.js";
import "../../../v1/views/admin-consent/ScopeList.js";
import "../../../v1/views/consent/ScopeList.js";
import "./captcha/CaptchaView.js";
import Util from "../../../util/Util.js";
const Body = BaseForm.extend({
  title: function() {
    return loc("password.reset.title.generic", "login");
  },
  save: function() {
    return loc("oform.next", "login");
  },
  initialize: function() {
    BaseForm.prototype.initialize.apply(this, arguments);
    const identifier = this.options.appState.get("lastIdentifier");
    if (identifier) {
      this.model.set("identifier", identifier);
      this.model.trigger("request");
      this.trigger("save", this.model);
    }
  },
  getUISchema: function() {
    const schemas = BaseForm.prototype.getUISchema.apply(this, arguments);
    let newSchemas = schemas.map((schema) => {
      let newSchema = __spreadValues({}, schema);
      if (schema.name === "identifier") {
        newSchema = __spreadProps(__spreadValues({}, newSchema), {
          autoComplete: Util.getAutocompleteValue(this.options.settings, "username")
        });
      }
      return newSchema;
    });
    return newSchemas;
  }
});
var IdentifyRecoveryView = BaseView.extend({
  Body,
  Footer: BaseFooter
});
export { IdentifyRecoveryView as default };
